import { SetState } from "zustand";
import { M_Error, M_Warning } from "../../common/Types";
import { DailyTaskI } from "../../interfaces/DailyTaskInterface";
import { MessageI } from "../../interfaces/interfaces";
import { AppStatesI } from "../interfaces/storeStatesInterface";

export const replaceObjFromList = (prevList: any[], newObj: any, field: string) =>
    prevList.map((_obj: any) => _obj[field] === newObj[field] ? newObj : _obj);

export const removeObjFromList = (prevList: any[], newObj: any, field: string) =>
    prevList.filter((_obj: any) => _obj[field] !== newObj[field]);

export const todayTask = (task: DailyTaskI) =>
    new Date(task.assignedDate).getDate() <= new Date().getDate();

export const convertResToMessage = (response: any): MessageI => {
    var message = {
        type: M_Warning,
        content: response.message || 'Something is wrong',
    };

    if (response.error) {
        var content = response.error.message || JSON.stringify(response.error);
        message = { type: M_Error, content };
    }

    return message;
};

export const setErrorMessage = (setState: SetState<AppStatesI>, res: any) => {
    var message = convertResToMessage(res);

    setState(_preState =>
    ({
        messages: [message, ..._preState.messages],
        isLoading: false
    }));
};